var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationExpectedPickupPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9866 8.31879C38.1874 11.8326 35.3581 14.7243 31.8179 14.7243C28.5994 14.7243 25.9348 12.3123 25.6591 9.21016H23.9726C23.3735 9.21016 22.8877 8.73521 22.8877 8.1498C22.8877 7.56412 23.3735 7.08944 23.9726 7.08944H25.6356V5.18107C25.6356 3.42762 27.0959 2 28.8894 2H34.7466C36.5401 2 38.0004 3.42789 38.0004 5.18107C38.0004 5.98186 37.9866 7.53126 37.9866 8.31879ZM27.8413 9.21016C28.1076 11.1384 29.7975 12.6033 31.8182 12.6033C33.8385 12.6033 35.5284 11.1384 35.7948 9.21016H27.8413ZM34.7466 4.12072H28.8894C28.2935 4.12072 27.8048 4.59843 27.8048 5.18107V7.08944H35.8312V5.18107C35.8312 4.59843 35.3426 4.12072 34.7466 4.12072Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7143,
    cy: 26.7143,
    r: 7.71429,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49414 30.9965C9.78929 30.9718 10.0593 30.8206 10.2345 30.5818L14.4892 24.7815C14.8236 24.3257 14.7251 23.6851 14.2692 23.3507C13.8134 23.0163 13.1728 23.1148 12.8384 23.5706L9.27952 28.4223L7.7374 26.9223C7.33215 26.5281 6.68406 26.537 6.28987 26.9423C5.89568 27.3476 5.90465 27.9956 6.30991 28.3898L8.69534 30.7101C8.90765 30.9166 9.19899 31.0211 9.49414 30.9965Z",
    fill: "#06CEA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.5V23.3828C37 22.4766 36.7635 21.5862 36.3139 20.7994V20.7994C35.4883 19.3545 34.0218 18.3913 32.3679 18.2075L32.2952 18.1995C31.1307 18.0701 29.9559 18.3265 28.9512 18.9293L28.6681 19.0991C28.2244 19.3654 27.815 19.685 27.4491 20.0509L22.5858 24.9142C22.2107 25.2893 21.702 25.5 21.1716 25.5H20.5M31 23L24.0763 29.4621C23.706 29.8078 23.2183 30 22.7117 30H20.5M26.5 34V27.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.1111V15C13 14.4477 13.4477 14 14 14H20C20.5523 14 21 14.4477 21 15V21.1111C21 21.602 20.602 22 20.1111 22V22H19.2222",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L17 14",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationExpectedPickupPositive);
export default __webpack_public_path__ + "static/media/notification-expected-pickup-positive.3d50101e668e672cd23def914c81ee79.svg";
export { ForwardRef as ReactComponent };